import * as React from 'react';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';

import { Typography } from '@mui/material';








export default function AnexoDetailsPage() {


  return (

    <div
      style={{
        height: '100%',
        display: "flex",
        width: '100%',
        backgroundColor: "#f6f6f6",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ flexDirection: 'row', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <DisplaySettingsIcon style={{ color: 'rgba(229, 29, 29, 0.7)', marginLeft: 10, marginBottom: 10 }} /><h3 style={{ color: 'rgba(229, 29, 29, 0.7)', alignSelf: 'flex-start', marginLeft: 15, marginBottom: 10 }}>
          Detalle de Anexos
        </h3>
      </div>

      <div
        style={{
          height: 'auto',
          display: "flex",
          width: '100%',
          backgroundColor: 'rgba(238, 238, 238, 0.9)',
          marginTop: 10,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        
        <Typography>
          Esta sección se encuentra en construcción.
        </Typography>

      </div>


    </div >
  );
}
